import { AuthContext } from "@zboxglobal/zboxauth";
import { useContext } from "react";
import useQueryString from "../../hooks/useQueryString";
import styles from "./SignIn.module.scss";

const SignIn = () => {
    const authContext = useContext(AuthContext);
    const queryString = useQueryString();
    let returnPath = queryString.getString("p") || "";
    if (!returnPath.startsWith("/")) returnPath = "/";

    return (
        <div className={styles.container}>
            <div className={styles.title}>
                Zbox Lawsuit Login
            </div>
            <div className={styles.formContainer}>
                <button
                    className={styles.interactiveLoginButton}
                    onClick={e => {
                        e.preventDefault();
                        authContext.client.InteractiveLogin(returnPath);
                    }}
                >
                    Use Interactive Login
                </button>
            </div>
        </div>
    );
};

export default SignIn;